import { render, staticRenderFns } from "./Valle.vue?vue&type=template&id=d246caec&scoped=true"
import script from "./Valle.vue?vue&type=script&lang=js"
export * from "./Valle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d246caec",
  null
  
)

export default component.exports